var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5094_11511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.92984 17.07C1.97473 16.1475 1.21291 15.044 0.688821 13.824C0.164731 12.604 -0.111131 11.2918 -0.122669 9.96397C-0.134207 8.63618 0.11881 7.31938 0.621618 6.09042C1.12443 4.86145 1.86696 3.74493 2.80589 2.80601C3.74481 1.86708 4.86133 1.12455 6.09029 0.62174C7.31926 0.118932 8.63605 -0.134085 9.96385 -0.122547C11.2916 -0.111009 12.6038 0.164853 13.8239 0.688943C15.0439 1.21303 16.1474 1.97486 17.0698 2.92996C18.8914 4.81598 19.8994 7.342 19.8766 9.96397C19.8538 12.5859 18.8021 15.0941 16.948 16.9481C15.0939 18.8022 12.5858 19.8539 9.96385 19.8767C7.34188 19.8995 4.81586 18.8915 2.92984 17.07ZM11.3998 9.99996L14.2298 7.16996L12.8198 5.75996L9.99984 8.58996L7.16984 5.75996L5.75984 7.16996L8.58984 9.99996L5.75984 12.83L7.16984 14.24L9.99984 11.41L12.8298 14.24L14.2398 12.83L11.4098 9.99996H11.3998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5094_11511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.b082d8ed97339803144c4058b9e9f663.svg";
export { ForwardRef as ReactComponent };